import { componentsModule as ShareBaseComponents } from 'sharebase/components';
import { servicesModule as ShareBaseServices } from 'sharebase/services'
import {
	ConfigureShareComponent,
	ManageSharesComponent
} from 'shaas/components';
import { shaasRoutes } from './shaas.routes';

export const ShaasModule = angular
	.module('sharebase.shaas', [
		ShareBaseComponents.name,
		ShareBaseServices.name
	])
	.component('shaasConfigureShare', ConfigureShareComponent)
	.component('shaasManageShares', ManageSharesComponent)
	.config([
		'$stateProvider',
		($stateProvider:ng.ui.IStateProvider) => {
			shaasRoutes.forEach(r => $stateProvider.state(r));
		}
	]);


// WEBPACK FOOTER //
// ./src/shaas/index.ts